import { AbsRequestMap } from './AbsRequestMap';
export class PostRequestMap extends AbsRequestMap {
    createReqBody() {
        // 해체 할당으로 기존 객체와 참조값 격리
        const _address = {
            ...this.data.selectedAddress?.data,
        };
        _address.buildingName = this.data.buildingName;
        _address.administrativeArea = this.data.administrativeArea;
        // 좌표 변경 on 시 변경한 좌표로 업데이트
        if (this.data.isChangePosition) {
            _address.location = this.data.newPosition;
        }
        const data = {
            areaType: this.data.areaTypeCode,
            type: this.data.type,
            operationType: this.data.operationType,
            operationDetailType: this.data.operationDetailType,
            address: _address,
        };
        // 수정일 때만 originId 추가
        if (this.data.operationType === 'UPDATE') {
            data.originId = String(this.data.selectedAddress?.id);
        }
        return data;
    }
}
